import { Container, Grid } from "@mui/material";
import { GetBankAccountForm, GetBankAccountList } from "store/api/BankAccounts";

import AddOrEditBankAccount from "./Component/AddOrEditBankAccount";
import BankAccountsCard from "./Component/BankAccountsCard";
import BankAccountsTable from "./Component/BankAccountsTable";
import ButtonAddBankAccounts from "./Component/ButtonAddBankAccounts";
import ConfirmDeleteBankAccount from "./Component/ConfirmDeleteBankAccount";
import Pagination from "components/Pagination";
import http from "config/http";
import { useEffect } from "react";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";

function BankAccounts() {
  const notify = useNotify();
  const isMobileView = useIsMobileView();

  const [searchParams] = useSearchParams();
  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 10;

  const [bankDataForm, setBankAccountForm] = useState();
  const [bankAccountList, setBankAccountList] = useState();
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);

  const [openAddOrEditBankAccount, setOpenAddOrEditBankAccount] =
    useState(false);

  const [openConfirmDeleteBankAccount, setOpenConfirmDeleteBankAccount] =
    useState(false);

  const getBankAccountForm = async () => {
    try {
      const { data } = await http.get(GetBankAccountForm);
      setBankAccountForm(data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const getBankAccountList = async ({ pageNumber, pageSize }) => {
    try {
      const { data } = await http.get(
        GetBankAccountList({
          bankId: 0,
          stateId: 0,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
      );
      setBankAccountList(data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleEditBankAccount = (bankAccount) => {
    setSelectedBankAccount(bankAccount);
    setOpenAddOrEditBankAccount(true);
  };

  const handleAddNewBankAccount = () => {
    setSelectedBankAccount(null);
    setOpenAddOrEditBankAccount(true);
  };

  const handleDeleteBankAccount = (bankAccount) => {
    setSelectedBankAccount(bankAccount);
    setOpenConfirmDeleteBankAccount(true);
  };

  useEffect(() => {
    getBankAccountForm();
    getBankAccountList({ pageNumber, pageSize });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePaginate = ({ page, perPage }) => {
    getBankAccountList({ pageNumber: page, pageSize: perPage });
  };

  return (
    <Container>
      <Grid container>
        <ButtonAddBankAccounts onClick={handleAddNewBankAccount} />

        {isMobileView ? (
          <BankAccountsCard
            bankAccountList={bankAccountList?.data}
            onClick={handleEditBankAccount}
          />
        ) : (
          <BankAccountsTable
            bankAccountList={bankAccountList?.data}
            handleEdit={handleEditBankAccount}
            handleDelete={handleDeleteBankAccount}
          />
        )}

        <Grid item xs={12}>
          <Pagination
            perPage={bankAccountList?.pageSize}
            count={bankAccountList?.totalPages}
            onChange={handleChangePaginate}
          />
        </Grid>
      </Grid>

      {openAddOrEditBankAccount && (
        <AddOrEditBankAccount
          getBankAccountList={() =>
            getBankAccountList({ pageNumber, pageSize })
          }
          bankDataForm={bankDataForm?.data?.lisBank}
          open={openAddOrEditBankAccount}
          onClose={() => setOpenAddOrEditBankAccount(false)}
          selectedBankAccount={selectedBankAccount}
        />
      )}

      {openConfirmDeleteBankAccount && (
        <ConfirmDeleteBankAccount
          open={openConfirmDeleteBankAccount}
          onClose={() => setOpenConfirmDeleteBankAccount(false)}
          selectedBankAccount={selectedBankAccount}
          getBankAccountList={() =>
            getBankAccountList({ pageNumber, pageSize })
          }
        />
      )}
    </Container>
  );
}
export default BankAccounts;
